import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"debounced-input",style:(_vm.inputStyles)},[_c(VTextField,_vm._b({ref:"textField",staticClass:"input-field",attrs:{"value":_vm.value},on:{"input":_vm.onInput,"click:clear":_vm.onClear}},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }